/* UTILITY */
import './utility/is-mobile';

/* FEATURES */
import "../features/judgeme/scripts";
import "../features/stickyCart/stickyCart";
import '../features/languageSelector/languageSelector';
import '../features/addBundle/addBundle';
import "../features/variantSelector/variantSelector";
import "../features/dropdown/dropdown";
import '../features/collectionPageDescription/collectionPageDescription';
import '../features/smoothScroll/smoothScroll';
import '../features/powerstep/powerstep';
import '../features/openSearchField/opensearchfield';
import '../features/colorSwatches/colorSwatches';
import '../features/connectedProducts/connectedProducts';

import '../features/smallFeatures/smallFeatures';
import '../features/filters/scripts';

import '../features/try-on/try-on-drawer';
import '../features/try-on/try-on-chat';
import '../features/try-on/try-on-add-to-cart-popup';
import '../features/searchSuggestions/scripts';
import '../features/modal/scripts';
import '../features/slickFiles/script/index';
import '../features/zappInstallation/zappInstallation';
import '../features/customizedFilter/index'
import '../features/footer/scripts';
import '../features/secondarySections/scripts';
import '../features/productReviews/scripts';
import '../features/productDescriptionIcons/scripts';
import '../features/stickyAddToCart/scripts';
import '../features/quicklinksIntegration/scripts';
import '../features/productInfo/scripts';
import '../features/loadmore/scripts';
import '../features/collectionPagePromo/scripts';
import '../features/klaviyoTrigger/scripts'



import '../components/global';
import '../components/facets';
import '../components/menuDrawer';
import '../components/showMoreButton';
